import React from 'react';

const BaselineComparisonLegend: React.FC = () => {
  return (
    <div className="mt-3 pt-2 border-t border-gray-200 dark:border-gray-700">
      <div className="flex items-center justify-between text-sm text-gray-600 dark:text-gray-300 mb-2">
        <span className="flex-shrink-0 font-medium">Below baseline</span>
        <div className="flex-1 mx-4 h-3 rounded-full bg-gradient-to-r from-blue-400 via-blue-200 via-gray-100 via-pink-200 to-pink-400 dark:from-blue-600/90 dark:via-blue-900/60 dark:via-gray-700 dark:via-pink-900/60 dark:to-pink-600/90 border border-gray-300 dark:border-gray-600"></div>
        <span className="flex-shrink-0 font-medium">Above baseline</span>
      </div>
      <div className="flex justify-between text-xs text-gray-500 dark:text-gray-400">
        <span>-3+</span>
        <span>-1</span>
        <span>0</span>
        <span>+1</span>
        <span>+3+</span>
      </div>
    </div>
  );
};

export default BaselineComparisonLegend;
